import { Page } from '@styled/Page';
import React from 'react';
import { FlexColItemLeft, FlexColItemRight } from '../../../styled/FlexWrappers';
function PermissionManagerLayout(_a) {
    var contentLeft = _a.contentLeft, contentRight = _a.contentRight;
    var left = (React.createElement(FlexColItemLeft, { "$flexGrow": true, "$maxHeight": "100%", "$flex": 2 }, contentLeft));
    var right = (React.createElement(FlexColItemRight, { "$flexGrow": true, "$maxHeight": "100%", "$flex": 4 }, contentRight));
    return (React.createElement(Page, null,
        React.createElement("div", { style: { display: 'flex', flexGrow: 1, height: 400 } },
            left,
            right)));
}
export default PermissionManagerLayout;
